<template lang="html">
<div id="buildings">
    <el-row class="headLine">
        <!-- 新建 -->
        <el-col :span="12" style="text-align:left;">
            <el-button @click="goInner" style="width:90px;" size="small" type="primary">新建</el-button>
        </el-col>
        <!-- 选择器 -->
        <div class="headright">
            <el-input placeholder="标题搜索" class="input" size="small">
                <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
        </div>
    </el-row>
    <RuleList ref="ruleColumn" />
</div>
</template>

<script>
import RuleList from './ruleList';
import {
    getArticleListByCondition
} from '@/api/jingshi';
// import { getBuildings } from '@/api/industryInfos';
export default {
    components: {
        RuleList
    },
    data() {
        return {
            canshu: {
                dto: {
                    columnId: '', // 栏目ID
                    keyword: '', // 关键词
                    status: '', // 1草稿、2待审核、3上线、4退回
                    property: '', // 1推荐属性、2热门属性、3推荐属性
                    class_type: "ArticleListCondition",
                },
                basePage: {
                    size: 12, // 分页大小
                    no: 1, // 当前分页
                }
            },
            aValue: '',
            bValue: '',
            cValue: '',
            // one
            options: [],
            options: [{
                    aValue: 1,
                    label: '新闻动态'
                },
                {
                    aValue: 2,
                    label: '活动预告'
                },
                {
                    aValue: 3,
                    label: '媒体报道'
                },
                {
                    aValue: 4,
                    label: '社会热点'
                },
                {
                    aValue: 5,
                    label: '京师党建'
                },
            ],
            // two
            twoOptions: [],
            twoOptions: [{
                    bValue: 1,
                    label: '推荐'
                },
                {
                    bValue: 2,
                    label: '热门'
                },
                {
                    bValue: 3,
                    label: '置顶'
                },
            ],
            // three
            threeOptions: [],
            threeOptions: [{
                    cValue: 1,
                    label: '草稿'
                },
                {
                    cValue: 2,
                    label: '待审核'
                },
                {
                    cValue: 3,
                    label: '上线'
                },
                {
                    cValue: 4,
                    label: '退回'
                }
            ],
        }
    },
    methods: {
        // 获取文章列表
        getList() {
            var vues = this;
            this.loading = true;
            getArticleListByCondition(this.canshu).then(res => {
                // this.showArr = this.canshu
                console.log(res);
                console.log(res.param.dto);
                vues.loading = false;
                // vues.showArr = res.cmsColumnLists;
                // console.log(vues.showArr);
            })
        },
        // 新建
        goInner() {
            this.$router.push('/ss_ment/rule_column_add');
        },
    },
    created() {

    }

}
</script>

<style lang="scss" scoped>
#buildings {
    font-size: 15px;
    background-color: #f5f5f5;
    min-height: 500px;

    .headLine {
        padding: 0 20px;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #ebeef5;
        background-color: #fff;
    }

    .seLect {
        width: 110px;
    }

    .headright {
        text-align: right;
        margin-right: 10px;

        .input {
            width: 260px;
            border-radius: none;
        }
    }
}
</style>

<style lang="css">
.headright .el-input__inner {
    border-radius: 0px !important;
}
</style>



// WEBPACK FOOTER //
// index.vue?0d187c31